
import React from 'react';
import { useNavigate } from 'react-router-dom';
import DiscoverySubSection from './DiscoverySubSection';
import { useDiscoverySubCategories } from '@/hooks/useDiscoverySubCategories';

interface DiscoverySubCategoriesViewProps {
  onProfileView: (userId: string) => void;
}

const DiscoverySubCategoriesView = ({ onProfileView }: DiscoverySubCategoriesViewProps) => {
  const navigate = useNavigate();
  const {
    newUsers,
    mostBuzzzedUsers,
    travelerUsers,
    favoriteUsers,
    theirFavoriteUsers,
    visitorsUsers,
    isLoadingNew,
    isLoadingBuzzz,
    isLoadingTravelers,
    isLoadingFavorites,
    isLoadingTheirFavorites,
    isLoadingVisitors
  } = useDiscoverySubCategories();

  const handleNewUsersClick = () => {
    navigate('/discovery/new');
  };

  const handleMostBuzzzClick = () => {
    navigate('/discovery/most-buzzz');
  };

  const handleTravelersClick = () => {
    navigate('/discovery/travelers');
  };

  const handleFavoritesClick = () => {
    navigate('/favorites');
  };

  const handleTheirFavoritesClick = () => {
    navigate('/discovery/their-favorite');
  };

  const handleVisitorsClick = () => {
    navigate('/discovery/visitors');
  };

  return (
    <div className="space-y-6">
      <DiscoverySubSection
        title="new"
        profiles={newUsers}
        onTitleClick={handleNewUsersClick}
        onProfileView={onProfileView}
        isLoading={isLoadingNew}
      />
      
      <DiscoverySubSection
        title="most buzzz"
        profiles={mostBuzzzedUsers}
        onTitleClick={handleMostBuzzzClick}
        onProfileView={onProfileView}
        isLoading={isLoadingBuzzz}
      />
      
      <DiscoverySubSection
        title="traveler"
        profiles={travelerUsers}
        onTitleClick={handleTravelersClick}
        onProfileView={onProfileView}
        isLoading={isLoadingTravelers}
      />
      
      <DiscoverySubSection
        title="favorites"
        profiles={favoriteUsers}
        onTitleClick={handleFavoritesClick}
        onProfileView={onProfileView}
        isLoading={isLoadingFavorites}
      />
      
      <DiscoverySubSection
        title="their favorite"
        profiles={theirFavoriteUsers}
        onTitleClick={handleTheirFavoritesClick}
        onProfileView={onProfileView}
        isLoading={isLoadingTheirFavorites}
      />
      
      <DiscoverySubSection
        title="visitors"
        profiles={visitorsUsers}
        onTitleClick={handleVisitorsClick}
        onProfileView={onProfileView}
        isLoading={isLoadingVisitors}
      />
    </div>
  );
};

export default DiscoverySubCategoriesView;
